"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
// https://mui.com/components/autocomplete/#multiple-values
const lodash_1 = require("lodash");
const index_1 = require("../index");
const react_1 = __importDefault(require("react"));
const Select = ({ onChange, textFieldProps, options, selectAll = false, renderValue, disableClearable, readOnly, disabled, value = null, ...props }) => {
    const allSelected = Array.isArray(props.value) && props.value.length >= options.length;
    const getOptions = () => {
        if (selectAll) {
            return [
                allSelected
                    ? {
                        label: 'Deselect All',
                        value: 'deselect_all',
                    }
                    : {
                        label: 'Select All',
                        value: 'select_all',
                    },
                ...options,
            ];
        }
        return options;
    };
    return (react_1.default.createElement(index_1.Autocomplete, { "data-testid": "select", ...props, options: getOptions(), disableCloseOnSelect: props.multiple, getOptionLabel: (option) => option.label, renderInput: (params) => {
            const inputProps = { ...(textFieldProps?.inputProps ?? {}), ...(params?.inputProps ?? {}) };
            return react_1.default.createElement(index_1.TextField, { ...textFieldProps, ...params, inputProps: inputProps });
        }, onChange: (_e, val) => {
            if (Array.isArray(val)) {
                if ((0, lodash_1.last)(val)?.label === 'Select All') {
                    //@ts-ignore
                    const availableOptions = options.filter((option) => !option.disabled);
                    return onChange(availableOptions);
                }
                if ((0, lodash_1.last)(val)?.label === 'Deselect All') {
                    //@ts-ignore
                    return onChange([]);
                }
            }
            if (!val) {
                //@ts-ignore
                onChange({ value: null });
            }
            return onChange(val);
        }, renderOption: (rProps, option, { selected }) => {
            if (option.disabled) {
                rProps['aria-disabled'] = true;
            }
            return (react_1.default.createElement("li", { ...rProps },
                props.multiple && (react_1.default.createElement(index_1.Checkbox, { color: "primary", checked: option.label === 'Deselect All' || selected, disabled: option.disabled })),
                renderValue?.(option) ?? option.label));
        }, renderTags: (tagValue, getTagProps) => tagValue.map((option, index) => (react_1.default.createElement(index_1.Chip, { label: option?.label, ...getTagProps({ index }), disabled: getOptions().find((o) => o.label === option?.label)?.disabled }))), disableClearable: disableClearable, readOnly: readOnly, disabled: disabled, value: value }));
};
exports.default = Select;
